import React from 'react'
import { GridCell } from '@progress/kendo-react-grid'
import { TdActions } from '@/components/tdActions'
import { Button } from '@/components/button'
import LoadingIndicator from '@/components/LoadingIndicator'

export const htmlCell = (props) => {
  return class HtmlCell extends GridCell {
    render () {
      const text = this.props.dataItem[this.props.field]
      return (<td>{<span dangerouslySetInnerHTML={{ __html: text }} />}</td>)
    }
  }
}

export const commandCell = (props) => {
  return class CommandCell extends GridCell {
    render () {
      if (this.props.dataItem.id === props.entityIdBeingDeleted) { return <TdActions><LoadingIndicator inline /></TdActions> }
      return (
        <TdActions>
          <Button
            iconOnly
            icon='pencil'
            onClick={() => props.editAnnouncement(this.props.dataItem)} />
          <Button
            icon='x'
            iconOnly
            confirmTitle='Common.Delete'
            confirmText='Common.AreYouSure'
            onClick={() => props.deleteAnnouncement(this.props.dataItem.id)} />
        </TdActions>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/announcements/gridButtons.js